<template>
  <div>
    <div class="section" :class="{ active: isActive }">
      <h3 @click="makeActive" @keypress="makeActive" :class="{ active: isActive }" class="name" tabindex="0">
        {{ name }}
        <span class="plusMinus"> </span>
      </h3>

      <div class="checkboxContainer" :class="{ active: open }">
        <div class="list">
          <div class="filter" v-for="option in options" :key="option.value">
            <a
              :id="option.value.getFullYear()"
              @click="emitChange(option)"
              @keypress="emitChange(option)"
              :class="{ active: isChecked(option.value) }"
              tabindex="0"
              >{{ option.value.getFullYear() }}</a
            >
            <button
              class="reset"
              v-if="isChecked(option.value)"
              v-on:click="clearTag(option)"
            >
              Clear
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

import { SearchAPIModels } from "search-api-client";

export default Vue.extend({
  name: "DateFilterDropDown",
  props: {
    name: {
      type: String,
      required: true,
      default: "Publish date"
    },
    options: {
      type: Array as () => SearchAPIModels.GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => []
    },
    active: {
      type: Array as () => SearchAPIModels.GenericSearchResponseFacetsCreatedItem[],
      required: true,
      default: () => []
    },
    isActive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return { selectedOption: 0 as number };
  },
  methods: {
    makeActive(): void {
      this.isActive = !this.isActive;
    },
    isChecked(value: Date): boolean {
      return (
        this.$props.active
          .map(function(
            e: SearchAPIModels.GenericSearchResponseFacetsCreatedItem
          ) {
            return e.value;
          })
          .indexOf(value) > -1
      );
    },
    emitChange(
      value: SearchAPIModels.GenericSearchResponseFacetsCreatedItem
    ): void {
      this.$emit("inputChange", value);
    },
    clearTag: function(
      tag: SearchAPIModels.GenericSearchResponseFacetsCreatedItem
    ): void {
      this.$emit("clearTag", tag);
    }
  }
});
</script>
